import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Connecticut = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Connecticut Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Property Condition Disclosure Report: Mandatory unless the seller
          opts out (with penalties).
        </Text>

        <Text style={styles.listItem}>
          2. Attorney Review: Strongly recommended for both parties.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          4.{' '}
          <Text style={styles.underline}>
            Residential Property Condition Report
          </Text>{' '}
          – Sellers must complete this form and present it to potential buyers
          prior to any binder or contract.
        </Text>
      </View>
    </View>
  );
};

export default Connecticut;
